// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__29e2p","boxTitle":"Qualiphy_boxTitle__PW4-y","box":"Qualiphy_box__kLSkU","toggleWrap":"Qualiphy_toggleWrap__3BZV6"};